import { getCustomerList } from '@/api/customer';
import { createCustomerPurview } from '@/api/customerPurview'
import Vue from 'vue'

const state = {
    customerPurviews:[],
    totalCounts: 0,
}

const actions = {
    // 创建客户权限
    async createCustomerPurviewAction({ commit }, payload) {
        try {
            const newCustomerPurview = await createCustomerPurview(payload);
            commit('ADDNEWCUSTOMERPURVIEW', newCustomerPurview.data)
        } catch (error) {
            throw error
        }
    },
}

const mutations = {
    ADDNEWCUSTOMERPURVIEW(state, customerPurview) {
        state.customerPurviews.unshift(customerPurview)
        state.totalCounts++
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}